import React, { useState } from "react";
import logoInitial from "../../assets/png/Netuno_Logo_dark.png";
import { textlogin } from "../../locales/es-es";
import { initialForm } from "../../propsType/SignIn";
import { useForm } from "../../Hooks/UseForm";
import { validationSingIn } from "../../validations/formValidations";
import { Link } from "react-router-dom";
import Spinner from "../../components/Loading/loadingSpinner/Spinner";
import { useNavigate } from "react-router-dom";
import InputGeneric from "../../components/Inputs/InputGeneric";
import { UseContextApp } from "../../Global/Context/appContext";
import { actionTypes } from "../../Global/actions/types";
import ButtonGeneric from "../../components/Buttons/ButtonGeneric";
import SelectGeneric from "../../components/Inputs/SelectGeneric";
import { optionLogin } from "../../propsType/SignUp";
import { extrac } from "../../helpers/selectForm";
import AuthController from "../../controllers/AuthController";
import ConsumoController from "../../controllers/ConsumoController";
import error from "../../assets/png/error.png";
import Modal from "../../components/Modals/Modal";
import ModalSesion from "../../components/Modals/Modal";
import { getInitial } from "../../helpers/getInitials";
import { colors } from "../../propsType/Colors";
import { useEffect } from "react";
import { forbiddenCharacters, handlePasswordKeyDown } from "../../validations/forbiddenCharacters";

const SignIn = () => {
  const navigate = useNavigate();
  const [{ user }, dispatch] = UseContextApp();
  const { consumo } = ConsumoController();
  const { signIn, verifyDoc, signOut } = AuthController();
  const [erros, setErros] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    form,
    setForm,
    errors,
    setErrors,
    handleChange,
    handleSubmit,
    handleBlur,
  } = useForm(initialForm, validationSingIn);
  const [message, setMessage] = useState("");
  const [messageSesion, setMessageSesion] = useState("");
  const [modal, setModal] = useState(false);
  const [img, setImg] = useState("");
  const [icon, setIcon] = useState(false);
  const [client, setClient] = useState("");
  const [vetronis, setVetronis] = useState(true);
  const [showLogin, setShowLogin] = useState(false);



  const funtionShowLogin = () => { setShowLogin(!showLogin); };

  const handleRedirect = (e) => {
    e.preventDefault();

    const url = "/cuenta?send_message=cambiar%20contrase%C3%B1a";

    navigate(url);

    window.location.href = url

  }

  const sendLogin = async () => {
    const result = handleSubmit();
    if ((result === "ok") || (form.selectDoc !== "" && form.selectDoc !== "Selección" && form.typeDoc.toString().length > 5 && form.password !== "")) {
      setLoading(true);
      let { selectDoc, password, typeDoc } = form;
      
      if (selectDoc === "Cédula Extranjera") {
        typeDoc = "E" + typeDoc; 
      }

      const result = extrac(selectDoc);
      let newObjet = {
        result,
        password,
        typeDoc,
      };

      signIn(newObjet).then(async (data) => {
        if (data?.respuesta === 0) {
          const resDoc = await verifyDoc({
            id: newObjet.typeDoc,
            type: newObjet.result,
            token: data?.token,
          });

          if ((resDoc.status === 99) || (resDoc.status === 1)) {

            setLoading(false);
            setErros(true);
            setMessage(
              "Ha ocurrido un error, por favor inténtelo de nuevo más tarde."
            );
            setImg(error);
            setIcon(false);
          }
          else {
            const initName = getInitial(resDoc.nombreApellido);
            dispatch({
              type: actionTypes.USER_AUTH,
              payload: {
                id: typeDoc,
                idCliente: data["idCliente "],
                token: data.token,
                type: newObjet.result,
                datos: resDoc,
                initial: initName,
              },
            });
            localStorage.setItem(
              "idToken",
              JSON.stringify({
                id: typeDoc,
                type: newObjet.result,
                token: data.token,
                idCliente: data["idCliente "],
                ctaAbonado: resDoc.ctaAbonado,
              })
            );
            // navigate("/dashboard", { state: { id: typeDoc } });
            const res = await consumo({
              id: typeDoc,
              token: data.token,
              type: newObjet.result,
            });

            if (res) {
              if (res.status === 1) {
                setLoading(false);
                setErros(true);
                setMessage(
                  "Ha ocurrido un error, por favor inténtelo de nuevo más tarde."
                );
                setImg(error);
                setIcon(false);
                const res = await signOut(data);
                setTimeout(() => {
                  localStorage.clear()
                  navigate('/cuenta');
                  setLoading(false)
                }, 3000);

              }
              if (res.status === 99) {
                setLoading(false);
                setErros(true);
                setMessage(
                  "Ha ocurrido un error, por favor inténtelo de nuevo más tarde."
                );
                setImg(error);
                setIcon(false);

              }
              if (res.status === -1 || res.status === 0) {
                localStorage.setItem(
                  "idToken",
                  JSON.stringify({
                    id: typeDoc,
                    type: newObjet.result,
                    token: data.token,
                    idCliente: data["idCliente "],
                  })
                );

                setLoading(true);
                setErrors(false);
                navigate("/cuenta/dashboard", { state: { id: form.typeDoc } })
                //setModal(true);
                //setMessageSesion("Si posees una sesión activa en otro ordenador o dispositivo, será finalizada en este momento.");
                // navigate("/dashboard", { state: { id: typeDoc } });
              }
            }
          }
        }
        else if (data.respuesta === -3) {
          setLoading(false);
          setErros(true);
          switch (data.descripcion) {
            case "La contraseña es invalida": setMessage("La contraseña es inválida. Verifique los datos e intenta nuevamente."); break;
            case "El documento de identidad del cliente no existe en sistema ": setMessage("El usuario no Existe, ingresa en Registrar Cuenta, completa la información, activa tu registro e ingresa nuevamente."); break;
            case "El usuario no existe": setMessage("Para acceder, realiza la activación de tu cuenta. Ubica el email de activación en tu correo electrónico; no olvides validar buzón spam o correos no deseados."); break;
            case "Error no controlado de Login": setMessage("Ha ocurrido un problema al iniciar sesión. Comunícate a través de nuestros diferentes medios de contacto."); break;
            default: setMessage(data.descripcion); break;
          }
          //setMessage("El usuario no Existe, ingresa en Registrar Cuenta, completa la información, activa tu registro e ingresa nuevamente.")
          setIcon(false);
        }
        else {
          setLoading(false);
          setErros(true);
          setMessage("Ha ocurrido un error, por favor inténtelo de nuevo más tarde.")
        }
      });
    }

  };


  const handleKeyDown = (event) => {
    if (event.key === 'Enter') { sendLogin(); }
  };

  const handle = (e) => {
    setErrors("");
    setForm({ ...form, selectDoc: "", typeDoc: "", password: "" });
    setClient(e);
  };
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }
  useEffect(() => {
    let res = localStorage.getItem("error");
    setVetronis(res);


  }, [vetronis]);

  function filtro(e) {
    if (form.selectDoc !== "Pasaporte") {
      var tecla = e.key;
      if (['.', 'e', 'E'].includes(tecla))
        e.preventDefault()
    }
  }


  return (
    <>
      <div
        className={` ${vetronis === "bantlo_" && " opacity-0 hidden"
          } h-screen lg:flex`}
      >
        <div className="flex-1 flex flex-col w-auto lg:w-[44%] ɐzsʎuuǝʞ h-screen py-4 xl:overflow-hidden justify-center  px-4 sm:px-6 md:flex-none lg:px-0 xl:px-0">
          {loading ? (
            <>
              <Spinner title={"Ingresando"} />
            </>
          ) : (
            <>
              <div className="mx-auto w-full overflow-y-auto lg:px-[100px] 2xl:px-[160px] md:px-[70px]  lg:mt-0 px-4 xl:max-[100%] xl:w-[100%] ">
                <div>
                  <a href="https://www.netuno.net/" target="_blank"  data-title="Ir al Inicio">
                    <img  src={logoInitial} data-title="Ir al Inicio" />
                  </a>

                  <h2 className="mt-6 mb-2 text-3xl font-extrabold text-gray-900">
                    {" "}
                    {textlogin.ingresar}{" "}
                  </h2>
                  <p
                    className={`text-sm font-medium text-[${colors.darkBlue}]`}
                  >
                    {textlogin.acceder}{" "}
                  </p>
                </div>
                <div className="mt-8">
                  <div>
                    <div>
                      <div className="mt-1 grid  gap-3">
                        <div className="text-sm font-medium text-gray-900">
                          {" "}
                          {textlogin.doc}
                        </div>
                        <div className="grid !mt-1  grid-cols-7">
                          <div className="col-span-2">
                            <SelectGeneric
                              onChange={handleChange}
                              value={form.selectDoc}
                              name={"selectDoc"}
                              onBlur={handleBlur}
                              errors={errors.selectDoc}
                              selectData={optionLogin}
                            />
                          </div>
                          <div className="col-span-5">
                            <InputGeneric
                              name={"typeDoc"}
                              type={form?.selectDoc === "Pasaporte" ? "text" : "number"}
                              value={form.typeDoc}
                              onKeyDown={(e) => filtro(e)}
                              onChange={handleChange}
                              handleBlur={handleBlur}
                              errorText={errors.typeDoc}
                              maxValue={13}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-6">
                    <div className="space-y-6">
                      <InputGeneric

                        title={textlogin.password}
                        errorText={errors.password}
                        handleBlur={handleBlur}
                        onChange={handleChange}
                        type={showLogin ? "text" : "password"}
                        show={showLogin}
                        funtionShow={funtionShowLogin}
                        name={"password"}
                        value={form.password}
                        onKeyDown={(e) => {
                            handleKeyDown(e);
                            handlePasswordKeyDown(e);
                        }}
                      />
                      <div>
                        <ButtonGeneric
                          funtion={sendLogin}
                          text={"Iniciar Sesión"}
                        />
                      </div>
                      <div className="flex items-center justify-between">
                        <div className="flex items-center">
                          <div className="text-sm">
                            <Link
                              to={"/cuenta/signUp"}
                              className={`font-medium text-[${colors.darkBlue}] hover:text-[${colors.darkBlue}]`}
                            >
                              {textlogin.registrar}
                            </Link>
                          </div>
                        </div>

                        <div className="text-sm">
                          <Link
                            // to={"/cuenta/new-password"}
                            onClick={handleRedirect}
                            className={`font-medium text-[${colors.darkBlue}] hover:text-[${colors.darkBlue}]`}
                          >
                            {textlogin.olvidado}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div
          className={`hidden bg-[url("../public/banner.jpg")] border-[${colors.darkBlue}] border-l-4 bg-cover bg-center bg-no-repeat lg:block relative w-0 flex-1`}
        ></div>
      </div>
      <Modal
        string={"error"}
        active={erros}
        message={message}
        setActive={setErros}
      >
        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <button
            type="button"
            onClick={() => setErros(false)}
            className="inline-flex w-full justify-center rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
          >
            Cerrar
          </button>
        </div>
      </Modal>
      <ModalSesion
        message={messageSesion}
        active={modal}
        setActive={setModal}
      >
        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <button
            type="button"
            // onClick={() => setErros(false)}
            onClick={() => {
              setModal(false)
              navigate("/cuenta/dashboard", { state: { id: form.typeDoc } })
            }}
            //className="hover:border-[#09101F] hover:text-[#09101F]  hover:bg-white w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white transition-all ease-linear 1s"
            className="inline-flex w-full justify-center rounded-md bg-[#09101F] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[#09101F] sm:ml-3 sm:w-auto"
          >
            Cerrar
          </button>
        </div>
      </ModalSesion>
    </>
  );
};

export default SignIn;
